"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useRealTimeAudioPlayer: ()=>useRealTimeAudioPlayer
});
const external_react_namespaceObject = require("react");
const audio_js_namespaceObject = require("../utils/audio.js");
function useRealTimeAudioPlayer(analytics) {
    const [isPlaying, setIsPlaying] = (0, external_react_namespaceObject.useState)(false);
    const audioContextRef = (0, external_react_namespaceObject.useRef)(null);
    const audioQueueRef = (0, external_react_namespaceObject.useRef)([]);
    const currentSourceRef = (0, external_react_namespaceObject.useRef)(null);
    const isProcessingQueueRef = (0, external_react_namespaceObject.useRef)(false);
    const ensureAudioContext = (0, external_react_namespaceObject.useCallback)(async ()=>{
        if (!audioContextRef.current) audioContextRef.current = new AudioContext();
        if ('suspended' === audioContextRef.current.state) await audioContextRef.current.resume();
        return audioContextRef.current;
    }, []);
    const isInterrupted = (0, external_react_namespaceObject.useCallback)(()=>'yes' === localStorage.getItem('isAudioInterrupted'), []);
    const handleInterruption = (0, external_react_namespaceObject.useCallback)(async ()=>{
        if (isInterrupted()) {
            if (currentSourceRef.current) {
                currentSourceRef.current.stop();
                currentSourceRef.current.disconnect();
                currentSourceRef.current = null;
            }
            audioQueueRef.current = [];
            isProcessingQueueRef.current = false;
            setIsPlaying(false);
        }
    }, [
        isInterrupted
    ]);
    const processAudioChunk = (0, external_react_namespaceObject.useCallback)(async ({ base64AudioData, sampleRate })=>{
        const audioContext = await ensureAudioContext();
        const arrayBuffer = (0, audio_js_namespaceObject.base64ToArrayBuffer)(base64AudioData);
        const pcm16Array = new Int16Array(arrayBuffer);
        const float32Array = (0, audio_js_namespaceObject.convertPCM16ToFloat32)(pcm16Array);
        if (!float32Array || float32Array.some(isNaN)) throw new Error('Invalid audio data.');
        const buffer = audioContext.createBuffer(1, float32Array.length, sampleRate);
        buffer.copyToChannel(float32Array, 0);
        return buffer;
    }, [
        ensureAudioContext
    ]);
    const playNextInQueue = (0, external_react_namespaceObject.useCallback)(async ()=>{
        if (isProcessingQueueRef.current || 0 === audioQueueRef.current.length) return;
        isProcessingQueueRef.current = true;
        try {
            if (isInterrupted()) return void await handleInterruption();
            const nextItem = audioQueueRef.current.shift();
            if (!nextItem) {
                isProcessingQueueRef.current = false;
                setIsPlaying(false);
                return;
            }
            const buffer = await processAudioChunk(nextItem);
            const audioContext = await ensureAudioContext();
            if (currentSourceRef.current) {
                currentSourceRef.current.stop();
                currentSourceRef.current.disconnect();
            }
            const source = audioContext.createBufferSource();
            source.buffer = buffer;
            source.connect(audioContext.destination);
            currentSourceRef.current = source;
            source.onended = ()=>{
                currentSourceRef.current = null;
                isProcessingQueueRef.current = false;
                if (audioQueueRef.current.length > 0 && !isInterrupted()) playNextInQueue().catch((error)=>analytics.logError({
                        loggedFrom: 'useRealTimeAudioPlayer.playNextInQueue',
                        message: 'Error playing next audio chunk.',
                        error
                    }));
                else setIsPlaying(false);
            };
            source.start();
            setIsPlaying(true);
        } catch (error) {
            analytics.logError({
                loggedFrom: 'useRealTimeAudioPlayer.playNextInQueue',
                message: 'Failed to play audio chunk.',
                error
            });
            isProcessingQueueRef.current = false;
            if (audioQueueRef.current.length > 0 && !isInterrupted()) playNextInQueue().catch(console.error);
        }
    }, [
        processAudioChunk,
        ensureAudioContext,
        handleInterruption,
        isInterrupted,
        analytics
    ]);
    const playAudio = (0, external_react_namespaceObject.useCallback)(async (base64AudioData, sampleRate = 24000)=>{
        if (!base64AudioData) return;
        audioQueueRef.current.push({
            base64AudioData,
            sampleRate
        });
        if (!isPlaying && !isProcessingQueueRef.current && !isInterrupted()) await playNextInQueue();
    }, [
        isPlaying,
        playNextInQueue,
        isInterrupted
    ]);
    const stopPlayback = (0, external_react_namespaceObject.useCallback)(async ()=>{
        if (currentSourceRef.current) {
            currentSourceRef.current.stop();
            currentSourceRef.current.disconnect();
            currentSourceRef.current = null;
        }
        audioQueueRef.current = [];
        isProcessingQueueRef.current = false;
        setIsPlaying(false);
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        const onStorageChange = (event)=>{
            if ('isAudioInterrupted' === event.key) handleInterruption().catch(console.error);
        };
        window.addEventListener('storage', onStorageChange);
        const interval = setInterval(()=>handleInterruption().catch(console.error), 300);
        return ()=>{
            window.removeEventListener('storage', onStorageChange);
            clearInterval(interval);
            if (audioContextRef.current) {
                audioContextRef.current.close()?.catch(console.error);
                audioContextRef.current = null;
            }
        };
    }, [
        handleInterruption
    ]);
    return {
        isPlaying,
        queueLength: audioQueueRef.current.length,
        playAudio,
        stopPlayback,
        clearQueue: stopPlayback
    };
}
exports.useRealTimeAudioPlayer = __webpack_exports__.useRealTimeAudioPlayer;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "useRealTimeAudioPlayer"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
